export const monthPickerFormFormat = "MM.yyyy";
export const monthPickerDisplayFormat = "MM.yyyy";
export const datePickerFormFormat = "dd.MM.yyyy";
export const datePickerDisplayFormat = "dd.MM.yyyy";
export const isoDateFormat = "yyyy-MM-dd";

export const dateTimeFormat = "dd.MM.yyyy, H:mm";
export const timeFormat = "HH:mm";
